import { render, staticRenderFns } from "./SettingsDefault.vue?vue&type=template&id=c72780a8&scoped=true"
import script from "./SettingsDefault.vue?vue&type=script&lang=ts"
export * from "./SettingsDefault.vue?vue&type=script&lang=ts"
import style0 from "./SettingsDefault.vue?vue&type=style&index=0&id=c72780a8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72780a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c72780a8')) {
      api.createRecord('c72780a8', component.options)
    } else {
      api.reload('c72780a8', component.options)
    }
    module.hot.accept("./SettingsDefault.vue?vue&type=template&id=c72780a8&scoped=true", function () {
      api.rerender('c72780a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/SettingsDefault.vue"
export default component.exports